import { Grid } from "@mui/material";
import {
  addTeacherMessageToConversationRequest,
  deleteTeacherConversationsMessageRequest,
  getTeacherConversationsMessagesRequest,
  getTeacherConversationsRequest,
  getTeacherStudentRequest,
} from "api/requests";
import ChatBoxCm from "components/Chat";
import DrawerCM from "components/shared/Drawer";
import useHttp from "hooks/use-http";
import React, { useEffect, useState } from "react";

import Toast from "helper/toast";
import { validateFile } from "validations";

export default function TeacherConversation() {
  const [selectedReceiver, setSelectedReceiver] = useState(null);

  const { loading, request, isUploading, setUploadProgress, uploadProgress } =
    useHttp();

  // gp messsages state
  const [conversationData, setConversationData] = useState({
    data: null,
    count: 0,
  });

  // gp list state
  const [conversations, setConversations] = useState({
    data: null,
    count: 0,
  });

  // gp list state
  const [reciverList, setreciverList] = useState({
    data: null,
    count: 0,
  });

  // unSeen message
  const [unSeenCount, setUnSeenCount] = useState();

  ////////////////// refresh all date //////////////////
  const refresh = async () => {
    setreciverList({
      data: null,
      count: 0,
    });
    setConversationData({
      data: null,
      count: 0,
    });
    setConversations({
      data: null,
      count: 0,
    });
    setSelectedReceiver({
      name: null,
      id: 0,
    });

    await getConversation();
    await getStudents();
  };

  ////////////////// submit message //////////////////
  const onSubmit = async (values) => {
    let file = null;
    const fileTypeValidate =
      values?.file && values?.file.length
        ? validateFile(values.file, "فایل", 10_000_000, [
            "png",
            "jpg",
            "jpeg",
            "gif",
            "svg",
            "pdf",
            "zip",
            "7zip",
            "rar",
          ])
        : true;

    if (!fileTypeValidate) {
      return null;
    } else {
      file = values.file;
    }

    const res = await request({
      url: () =>
        addTeacherMessageToConversationRequest(
          {
            receiver_id: `${values.reciver_id}`,
            message: values?.text ?? null,
            file: file,
          },
          (progress) => setUploadProgress(progress)
        ),
      isFile: values.file ? true : false,
    });

    if (res) {
      await getConversation();
      await getConversationMessages(res.data.id);
    }
  };

  ////////////////// get messages //////////////////
  const getConversationMessages = async (
    id,
    reciver = "",
    newConversation = false
  ) => {
    if (!newConversation) {
      const res = await request({
        url: getTeacherConversationsMessagesRequest,
        values: id,
      });

      setSelectedReceiver({
        id: id,
        name: `${res?.data?.student?.first_name} ${res?.data?.student?.last_name}`,
      });

      await getConversation();

      if (res.data.messages.length < 1) {
        return setConversationData({
          data: null,
          count: 0,
        });
      } else {
        // messages
        const transformedData = res.data.messages.map((item) => ({
          id: item.id,
          reciver_id: item.receiver_id,
          sender_id: item.sender_id,
          text: item.message,
          is_reciver: item.sender_type === "teacher" ? 0 : 1,
          date: [item?.created_at?.string, item?.created_at?.timestamp],
          file: item.file,
          isSeen: item.is_seen || 1,
        }));

        setConversationData({
          data: transformedData,
          count: transformedData.length,
        });

        setUnSeenCount(res?.data?.teacher_new_message_count);
      }
    } else {
      setSelectedReceiver({
        id: id,
        name: reciver,
      });
      setConversationData({
        data: null,
        count: 0,
      });
    }
  };

  ////////////////// get Conversation //////////////////
  const getConversation = async () => {
    const { data: res } = await request({
      url: getTeacherConversationsRequest,
    });

    const transformedData = res.data.map((item) => ({
      id: item.id,
      reciver_id: item.student_id,
      sender_id: item.teacher_id,
      reciver_name: `${item?.student?.first_name} ${item?.student?.last_name}`,
      unSeenCount: item.teacher_new_message_count,
    }));

    setConversations({
      data: transformedData.length ? transformedData : null,
      count: transformedData.length,
    });
  };

  ////////////////// get teacher //////////////////
  const getStudents = async () => {
    const res = await request({
      url: getTeacherStudentRequest,
      values: { doesnt_have_conversation: 1 },
    });

    if (res.count > 0) {
      const transformedData = res.data.map((item) => ({
        id: item.id,
        label: `${item.first_name} ${item.last_name}`,
      }));

      setreciverList({
        data: transformedData.length ? transformedData : null,
        count: transformedData.length,
      });
    }
  };

  // delete a message
  const handleDeleteMessage = async (id) => {
    const res = await request({
      url: deleteTeacherConversationsMessageRequest,
      values: id,
    });

    if (res.data) {
      Toast({ type: "success", title: "پیام حذف" });
      await getConversationMessages(selectedReceiver.id);
    }
  };

  useEffect(() => {
    getConversation();
    getStudents();
  }, []);

  return (
    <DrawerCM title="گفت و گو با دانش آموز" $styledHeader>
      <Grid container my={4} style={{ position: "relative", zIndex: "0" }}>
        <Grid item xs={12}>
          <ChatBoxCm
            isLoading={loading}
            isUploading={isUploading}
            uploadProgress={uploadProgress}
            data={conversationData?.data}
            conversations={conversations?.data}
            unSeenCount={unSeenCount}
            receiverName={selectedReceiver?.name}
            receiverId={selectedReceiver?.id}
            count={conversationData?.count}
            reciverList={reciverList.data}
            onSelectConversation={getConversationMessages}
            submit={onSubmit}
            onDeleteMessage={handleDeleteMessage}
            onRefresh={refresh}
          />
        </Grid>
      </Grid>
    </DrawerCM>
  );
}
